import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"overflow-hidden"},[_c('div',{staticClass:"d-inline-block mt-n12"},[_c(VImg,{attrs:{"src":"/kk-1.png","eager":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }